import Splide from '@splidejs/splide';
import { gsap } from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.addEventListener('DOMContentLoaded', function () {
  var sliders = document.querySelectorAll('.projects-slider-block.splide');
  sliders.forEach(function (slider) {
    if (typeof Splide !== 'undefined') {


      var splide = new Splide(slider, {
        type: 'slide',
        perPage: 3,
        breakpoints: {
          781: {
            perPage: 1,
          },
          2560: {
            perPage: 2,
          },
        },
        perMove: 1,
        drag: 'drag',
        padding: { right: '12vw' },
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        speed: 800,
        gap: 'var(--wp--preset--spacing--30)',
        arrows: false,
        pagination: false,
        lazyLoad: true,
        autoplay: false,
        rewind: true,

      });

      var bar = splide.root.querySelector('.slider-progress-bar');
      splide.on('mounted move', function () {
        var end = splide.Components.Controller.getEnd() + 1;
        var rate = Math.min((splide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + '%';
      });

      splide.on('ready', function () {
        const items = slider.querySelectorAll(".splide__slide");
        if (!items.length) return;

        gsap.set(items, { autoAlpha: 0, y: 30 });

        const st = ScrollTrigger.create({
          trigger: slider,
          start: "top 80%",
          end: "bottom 20%",
          markers: false,
          onEnter: () => {
            gsap.to(items, {
              autoAlpha: 1,
              y: 0,
              duration: 0.6,
              ease: "power2.out",
              stagger: 0.2,
              overwrite: 'auto',
            });
          }
        });
      });


      splide.mount();



    }
  });
});
